module.exports = __webpack_public_path__ + "img/1.f82d2303.png";